import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { TecAssuredStore } from "../../../../../../stores/TecAssuredStore";
import {
	getDocument,
	finalizeAgreement,
} from "../../../../../../api/TecAssuredAPI";
import { displayPdf } from "../../../../../../api/FormsAPI";
import useCurrentDealStore from "../../../../../../stores/DealStore";
import shallow from "zustand/shallow";
import { useFromUser } from "../../../../../../stores/LocalStorageHelper";
import dayjs from "dayjs";

const TecAssuredFinalizeTab = () => {
	const { agreementReqBody, setAgreementReqBody } = TecAssuredStore();
	const [finalized, setFinalized] = useState(false);
	const [loading, setLoading] = useState({
		preview: false,
		finalize: false,
		finalDoc: false,
	});

	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");

	const { warrantyList, editWarrantyList, dealRecNum, type, calculate } =
		useCurrentDealStore(
			(state) => ({
				warrantyList: state.warranty,
				editWarrantyList: state.editWarranty,
				dealRecNum: state.deal.ID,
				type: state.deal.type,
				calculate: state.calculate,
			}),
			shallow
		);

	// TecAssured returns -1 when values are n/a
	const handleNeg = (val) => {
		return val === -1 ? null : val;
	};
	const addServCon = (agreement) => {
		const newWarranty = {
			amount: handleNeg(parseFloat(agreement.Products.Amount)),
			term: handleNeg(parseInt(agreement.Products.Months)),
			miles: handleNeg(parseInt(agreement.Products.Miles)),
			deductible: handleNeg(parseFloat(agreement.Products.PrimaryDeductible)),
			contractNo: agreement.Products.AgreementNumber,
			expMiles: handleNeg(parseInt(agreement.Products.ExpireMiles)),
			expires: dayjs(agreement.Products.ExpireDate).format("YYYY-MM-DD"),
			cost: handleNeg(parseFloat(agreement.Products.DealerCost)),
			coRecNum: null, // tecAssured vendor ID later?
			description: agreement.Products.Product,
			dealerID,
			locationID,
			ID: null,
			dealRecNum,
			tecAssuredDocId: agreement.Products.DocumentID,
		};
		const warrList = () => {
			let newObj = [...warrantyList];
			newObj.push(newWarranty);
			return newObj;
		};
		const newWarrantyObj = warrList();
		editWarrantyList(newWarrantyObj);
		calculate();
	};

	const handlePreview = async () => {
		setLoading((prev) => ({ ...prev, preview: true }));
		try {
			const { Products } = agreementReqBody?.Agreement || {};
			if (Products?.DocumentID) {
				const res = await getDocument({
					documentId: Products.DocumentID,
					locationId: locationID,
				});
				displayPdf(res);
			}
		} finally {
			setLoading((prev) => ({ ...prev, preview: false }));
		}
	};

	const handleFinalize = async () => {
		setLoading((prev) => ({ ...prev, finalize: true }));
		try {
			const res = await finalizeAgreement(agreementReqBody);
			if (res?.data?.Products?.DocumentID) {
				setAgreementReqBody({
					locationId: locationID,
					Agreement: res.data,
				});
				setFinalized(true);
				addServCon(res.data);
				// TODO handle adding a new service contract to the warranty list
			}
		} finally {
			setLoading((prev) => ({ ...prev, finalize: false }));
		}
	};

	const handleGetFinalDoc = async () => {
		setLoading((prev) => ({ ...prev, finalDoc: true }));
		try {
			const { Products } = agreementReqBody?.Agreement || {};
			if (Products?.DocumentID) {
				const res = await getDocument({
					documentId: Products.DocumentID,
					locationId: locationID,
				});
				displayPdf(res);
			}
		} finally {
			setLoading((prev) => ({ ...prev, finalDoc: false }));
		}
	};

	return (
		<Row className="mt-4" form>
			<Col xs="12" md="4" className="mb-2">
				<Button
					color="secondary"
					block
					onClick={handlePreview}
					disabled={finalized || loading.preview}
				>
					{loading.preview ? "Previewing..." : "Preview"}
				</Button>
			</Col>

			<Col xs="12" md="4" className="mb-2">
				<Button
					color="primary"
					block
					onClick={handleFinalize}
					disabled={finalized || loading.finalize}
				>
					{loading.finalize ? "Finalizing..." : "Finalize"}
				</Button>
			</Col>

			<Col xs="12" md="4" className="mb-2">
				<Button
					color="success"
					block
					onClick={handleGetFinalDoc}
					disabled={!finalized || loading.finalDoc}
				>
					{loading.finalDoc ? "Loading..." : "Get Final Document"}
				</Button>
			</Col>
		</Row>
	);
};

export default TecAssuredFinalizeTab;
